// src/pages/StagePage.js
import React from "react";

const getReadableTextColor = (hex = "#111827") => {
  const normalized = hex.replace("#", "");
  if (normalized.length !== 6) return "#ffffff";

  const r = parseInt(normalized.slice(0, 2), 16);
  const g = parseInt(normalized.slice(2, 4), 16);
  const b = parseInt(normalized.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.62 ? "#111827" : "#ffffff";
};

export default function StageNavBar({ stage }) {
  const headerColor = stage.colors?.header || "#111827";
  const textColor = getReadableTextColor(headerColor);

  return (
    <nav
      style={{ backgroundColor: headerColor, color: textColor }}
      className="flex items-center border-b border-white/10 px-5 py-4 shadow-[0_18px_60px_-45px_rgba(2,6,23,0.75)] sm:px-8"
    >
      <div className="mx-auto flex w-full max-w-[1400px] items-center justify-between gap-4">
        <div className="flex min-w-0 items-center gap-4">
          {stage.logo_url ? (
            <span className="flex h-12 max-w-[220px] items-center">
              {/* No background box: keeps PNG/SVG transparency intact so the
                  logo sits directly on the header color. */}
              <img
                src={stage.logo_url}
                alt={`${stage.event_name || "Page"} logo`}
                className="max-h-10 max-w-full object-contain"
              />
            </span>
          ) : (
            <span className="grid h-11 w-11 flex-none place-items-center rounded-lg bg-white/12 text-sm font-bold uppercase shadow-[inset_0_1px_0_rgba(255,255,255,0.18)] ring-1 ring-white/15">
              {(stage.event_name || "V").slice(0, 1)}
            </span>
          )}

          <div className="min-w-0">
            <p className="truncate text-sm font-semibold opacity-75">Now viewing</p>
            <h1 className="truncate text-lg font-semibold tracking-tight sm:text-xl">
              {stage.title || stage.event_name || "Video page"}
            </h1>
          </div>
        </div>
      </div>
    </nav>
  );
}
